export const FLAG_GETTING_EXPENSE_SAP_MIGRATIONS = 'FLAG_GETTING_EXPENSE_SAP_MIGRATIONS';
export const GET_EXPENSE_SAP_MIGRATIONS = 'GET_EXPENSE_SAP_MIGRATIONS';
export const CLEAR_EXPENSE_SAP_MIGRATIONS = 'CLEAR_EXPENSE_SAP_MIGRATIONS';
export const FLAG_EXPENSE_SAP_MIGRATION_ACTIVITY = 'FLAG_EXPENSE_SAP_MIGRATION_ACTIVITY';
export const GET_EXPENSE_SAP_MIGRATION = 'GET_EXPENSE_SAP_MIGRATION';
export const CLEAR_EXPENSE_SAP_MIGRATION = 'CLEAR_EXPENSE_SAP_MIGRATION';
export const GET_EXPENSE_SAP_MIGRATIONS_BY_EXPENSE = 'GET_EXPENSE_SAP_MIGRATIONS_BY_EXPENSE';
export const CLEAR_EXPENSE_SAP_MIGRATIONS_BY_EXPENSE = 'CLEAR_EXPENSE_SAP_MIGRATIONS_BY_EXPENSE';